import Vue from 'vue';
import App from './App.vue';
import VueLoading, { VueLoadingOptions } from 'vue-loading-template';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueHead from "vue-head";

declare global {
  interface Window {
    MP_SDK: any
  }
}
window.MP_SDK = window.MP_SDK || {};

Vue.config.productionTip = false;
Vue.use(VueHead, { separator: '-'});
Vue.use<VueLoadingOptions>(VueLoading);
// イベントハブのインスタンスを$eventHubとして共通利用する
declare module 'vue/types/vue' {
  interface Vue {
    $eventHub: Vue
  }
}
Object.defineProperty(Vue.prototype, '$eventHub', { value: new Vue() });
// Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
